/* eslint-disable*/

import {
  Box,
  Typography,
  Tooltip,
  IconButton
} from '@material-ui/core'; // eslint-disable-line
import { useSelector, useDispatch } from 'react-redux';
import {
  amazon_100items,
  rakuten_100items,
  yahoo_100items
} from 'feactures/category/categoryRankSlice';
import RankingList from './RankingList';
import { currentchannel } from 'feactures/channel/channelSlice';
import download_icon from '../../layout/dashboard/icons/download_icon.svg';
import {
  exportStatus_categoryRank,
  fetchExport_categoryRank
} from 'feactures/monitoring/exportSlice';

const RankingTotal = (props) => {
  const { yokoziku } = props;
  const a_100items = useSelector(amazon_100items);
  const r_100items = useSelector(rakuten_100items);
  const y_100items = useSelector(yahoo_100items);
  const channel = useSelector(currentchannel);
  const exportStatus = useSelector(exportStatus_categoryRank);
  const dispatch = useDispatch();

  const renderSingle = (items) => (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography fontSize="14px" fontWeight="bold">
          TOP100商品
        </Typography>
        <Tooltip
          title={
            exportStatus
              ? 'CSVダウンロード中...'
              : (channel == 1 && items.length == 0) ||
                (channel == 2 && r_100items.length == 0) ||
                (channel == 3 && y_100items.length == 0)
              ? ''
              : 'CSVダウンロード'
          }
          placement="top"
        >
          <span>
            <IconButton
              onClick={() => {
                dispatch(fetchExport_categoryRank());
              }}
              disabled={
                exportStatus ||
                (channel == 1 && items.length == 0) ||
                (channel == 2 && r_100items.length == 0) ||
                (channel == 3 && y_100items.length == 0)
              }
              size="small"
            >
              <img
                src={download_icon}
                alt="ダウンロード"
                style={{ width: '20px' }}
              />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      <RankingList top100items={items.length > 0 ? items : []} yokoziku={yokoziku} />
    </>
  );

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      {channel == 1 ? renderSingle(a_100items) : null}
      {channel == 2 ? renderSingle(r_100items) : null}
      {channel == 3 ? renderSingle(y_100items) : null}
    </Box>
  );
};

export default RankingTotal;
